<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <BaseBlock title="Gestion des référents scolarité">
        <v-row>
          <v-col cols="12" md="10" offset="0" offset-md="1">
            <Referents
              :referents="referents"
              typeReferent="referentsScolarite"
              :closeRecherche="listeEnregistree"
              @addReferent="onAddReferent"
              @deleteReferent="onDeleteReferent"
            >
            </Referents> </v-col
        ></v-row>
        <v-row>
          <v-col cols="12" md="6" offset="0" offset-md="3">
            <div class="text-center">
              <v-btn
                class="mx-2"
                color="primary"
                @click="enregistrer"
                :loading="loading"
              >
                <v-icon left>save</v-icon>Enregistrer
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiScolariteRepository from "@/repositories/ApiScolariteRepository";
import Referents from "../components/Referents.vue";

export default {
  name: "GestionReferentsScolarite",
  components: { BaseBlock, Referents },

  data() {
    return {
      referents: [],
      loading: false,
      listeEnregistree: false,
    };
  },
  async created() {
    await this.getReferentsScolarite();
  },
  methods: {
    async getReferentsScolarite() {
      try {
        const referents = await ApiScolariteRepository.getReferentsScolarite();
        this.referents = referents;
      } catch (error) {
        if (error.response) {
          if (error.response.data.status !== 404) {
            this.$toast.error(error.response.data.messages[0]);
          }
        }
      }
    },
    async enregistrer() {
      this.loading = true;
      try {
        await ApiScolariteRepository.updateReferentsScolarite(this.referents);
        this.$toast.success("Liste des référents enregistrée");
        this.listeEnregistree = true;
        await this.getReferentsScolarite();
      } catch (error) {
        if (error.response) {
          if (error.response.data.status !== 404) {
            this.$toast.error(error.response.data.messages[0]);
          }
        }
      } finally {
        this.loading = false;
      }
    },
    onAddReferent(currentReferent) {
      this.referents.push(currentReferent);
    },
    onDeleteReferent(currentReferent) {
      this.referents = this.referents.filter(
        (referent) => referent.uid !== currentReferent.uid
      );
    },
  },
};
</script>
